// extracted by mini-css-extract-plugin
export default {"wrapper":"InitialStep_wrapper__KxY3G","title":"InitialStep_title__ve1Fx","text":"InitialStep_text__BgDoI","button":"InitialStep_button__5mbYP"};